(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wm-liminal"] && !Shopify.designMode) return;
  try {
    
function initializeLiminalMobile(section) {
  if (section.dataset.liminalReady) return;
  section.dataset.liminalReady = 'true';
  const quantity = section.querySelector('[name="quantity"]');
  const updateButtonPrices = () => {
    const count = Math.max(1, Number(quantity?.value) || 1);
    section.querySelectorAll('[data-liminal-button-price]').forEach(price => {
      price.textContent = new Intl.NumberFormat(document.documentElement.lang, {style: 'currency', currency: price.dataset.currency, minimumFractionDigits: 0, maximumFractionDigits: 2}).format(Number(price.dataset.unitPrice) * count / 100);
    });
  };
  quantity?.addEventListener('change', updateButtonPrices);
  const primary = section.querySelector('[data-liminal-primary]');
  const sticky = section.querySelector('[data-liminal-sticky]');
  const closing = section.querySelector('[data-liminal-closing]');
  if (!primary || !sticky || !('IntersectionObserver' in window)) return;
  const mobile = window.matchMedia('(max-width: 899px)');
  let passed = false;
  let closingVisible = false;
  const update = () => { sticky.hidden = !mobile.matches || !passed || closingVisible; };
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.target === primary) passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      if (entry.target === closing) closingVisible = entry.isIntersecting;
    }
    update();
  }, {threshold: 0});
  observer.observe(primary);
  if (closing) observer.observe(closing);
  mobile.addEventListener('change', update);
  section.addEventListener('shopify:section:unload', () => {observer.disconnect();mobile.removeEventListener('change', update);}, {once: true});
}
document.querySelectorAll('[data-liminal]').forEach(initializeLiminalMobile);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-liminal]').forEach(initializeLiminalMobile));

  } catch(e) { console.error(e); }
})();
})();
